'use client';

import type {ExtractContentBlockType} from '@/modules/foundation/sanity/content-blocks/ContentBlocks';

type Props = ExtractContentBlockType<'imageGalleryMasonry'>;

import {RowsPhotoAlbum} from 'react-photo-album';

import {
	galleryImageFromImageWeb,
	renderNextImage,
} from '@/modules/commerce/content-blocks/image-gallery-masonry/utils';
import {Container} from '@/modules/foundation/components/container';
import type {ImageWeb} from '@/modules/foundation/components/image/types';
import {Heading} from '@/modules/foundation/components/typography/heading';
import {Paragraph} from '@/modules/foundation/components/typography/paragraph';
import {imageWebFromImageWebSchema} from '@/modules/foundation/sanity/image/query';

// import 'react-photo-album/columns.css';
import 'react-photo-album/rows.css';

export const ImageGalleryMasonry = (props: Props) => {
	const {images, heading, description} = props;

	const imageWebPhotos: ImageWeb[] = [];

	if (images?.length) {
		for (const image of images) {
			if (image.asset?._ref) {
				const imageWeb = imageWebFromImageWebSchema(image);
				if (!imageWeb) {
					continue;
				}
				imageWebPhotos.push(imageWeb);
			}
		}
	}

	const photos = imageWebPhotos.map((image) => galleryImageFromImageWeb(image));

	return (
		<Container
			spacingBottom="normal"
			spacingTop="normal"
			className="bg-neutral-800/30"
			hasBackground
		>
			{heading && (
				<Heading
					level={2}
					spacing={Boolean(description?.length)}
					className="max-w-3xl text-balance"
				>
					{heading}
				</Heading>
			)}
			{description && (
				<Paragraph size="large" className="mb-4 max-w-3xl">
					{description}
				</Paragraph>
			)}

			<RowsPhotoAlbum
				photos={photos}
				render={{image: renderNextImage}}
				defaultContainerWidth={1200}
				sizes={{
					size: '1168px',
					sizes: [{viewport: '(max-width: 1200px)', size: 'calc(100vw - 32px)'}],
				}}
				rowConstraints={(containerWidth) => {
					if (containerWidth < 600) {
						return {maxPhotos: Math.min(2, photos.length)};
					}
					return {maxPhotos: Math.min(3, photos.length)};
				}}
			/>
		</Container>
	);
};
